import _lodash from 'lodash'
import CaregiversSubAPI from '../../api/catregiver_subcategory'
import {catalogs as mutations} from '../types/mutation-types'
import {catalogs as actions} from '../types/action-types'

export default {
  namespaced: true,
  state: {
    loading: false,
    quote: {},
    allData: [],
    subcategory:[]
  },
  getters: {
    loading (state) {
      return state.loading
    },
 
    subcategory (state) {
      //console.log(state.subcategory);
     
      return _lodash.get(state.subcategory, 'items', [])

    }
  },
  mutations: {
    [mutations.CATALOGS_REQUEST] (state) {
      state.loading = true
    },
    [mutations.CATALOGS_SUCCESS] (state, data) {
      state.loading = false
      state.allData = data
    },
    [mutations.CATALOGS_ERROR] (state) {
      state.loading = false
      state.allData = []
      state.subcategory = []
    },
    [mutations.CATALOGS_QUOTE] (state, quote) {
      state.quote = quote
    },
    [mutations.CATALOGS_SUBCATEGORY] (state, subcategory) {
      
      state.subcategory = subcategory
    }
  },
  actions: {

    
     [actions.FETCH_CAREGIVER_SUBCATEGORY] ({commit},category_id) {
      commit(mutations.CATALOGS_REQUEST)
      return CaregiversSubAPI.subcaregivers_categories(category_id)
        .then((res) => (commit(mutations.CATALOGS_SUBCATEGORY, res.data)))
        
        .catch(error => {
          console.warn(error)
          commit(mutations.CATALOGS_ERROR)
        })

    },

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/catregiver_subcategory.js